import { render } from "./publish.vue?vue&type=template&id=7c1eced8&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"

import "./publish.vue?vue&type=style&index=0&id=7c1eced8&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1eced8"]])

export default __exports__